import { NgClass } from '@angular/common';
import { Component, computed, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './step-1.component.html',
  standalone: true,
  selector: 'app-onboarding-step-1',
  imports: [MatButtonModule, NgClass, TranslatePipe],
  styles: `
    button[mat-button],
    button[mat-flat-button] {
      --mdc-filled-button-container-height: 36px;
      --mdc-text-button-container-height: 36px;
    }
  `,
})
export class Step1Component {
  readonly back = output<void>();
  readonly continue = output<number>();

  readonly selectedType = signal(-1);

  readonly continueDisabled = computed(() => this.selectedType() < 0 || this.selectedType() > 3);

  onContinue() {
    if (this.continueDisabled()) return;

    this.continue.emit(this.selectedType());
  }
}
